import styled from 'styled-components';
import { OffersViewProps } from './CityscapeOffersContainer';
import MHeader from './MHeader';
import { useSelector } from 'react-redux';
import CityscapeOffersFilter from './CityscapeOffersFilter';
import CTA from '../../../new-components/ui/CTA';
import { CTATypes } from '../../../new-lib/constants/common';
import CountdownBanner from './CountdownBanner';

const OffersView = ({
  getCardsContainer,
  offersStartDate
}: OffersViewProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <Container className="container-fluid">
      <div className="header">
        {isMobile && <MHeader />}
        <CityscapeOffersFilter />
        {!isMobile && offersStartDate && (
          <CountdownBanner endDate={offersStartDate} />
        )}
      </div>
      {isMobile && offersStartDate && (
        <CountdownBanner endDate={offersStartDate} />
      )}

      <div className={`results-container`}>{getCardsContainer()}</div>

      {isMobile && (
        <div className="cta">
          <CTA entity={{}} entityType={CTATypes.OFFERS} />
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 !important;

  .header {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 16px;
  }

  .results-container {
    position: relative;
    min-height: 300px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    gap: 16px;

    .results-container {
      padding: 0 16px;
    }

    .header {
      position: sticky;
      display: flex;
      flex-direction: column;
      top: 60px;
      z-index: 9999;
      width: 100vw;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .cta {
      position: fixed;
      bottom: 0;
      padding: 16px;
      background: #fff;
      display: flex;
      flex-direction: row;
      gap: 8px;
      justify-content: space-evenly;
      width: 100%;
      button {
        min-width: 160px;
      }
    }
  }
`;

export default OffersView;
